import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	replacedByParentField: {
		id: 'issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field',
		defaultMessage: 'Replaced by <strong>Parent</strong> field',
		description:
			'Text to display on the Epic Link field indicating that the Epic Field is no longer used and the user should instead use the Parent field',
	},
});
